export enum Status {
  Moved = "moved",
  Merged = "merged",
  MergeItem = "mergeitem"
}

export let ITEM_TEMPLATE = "";
export let DIALOG_TEMPLATE = "";
export let EDIT_TEMPLATE = "";
export let DRAGHANDLE_TEMPLATE = "";

export const SELECTOR: Record<string, string> = {
  PREFIX_MOVED: "moved-",
  PREFIX_MERGED: "merged-",

  CONTAINER: "listmerger",
  MERGELIST_CONTAINER: "mergelist-container",
  MERGELIST: "mergelist",
  LIST: "list",

  ITEM: "item",
  ITEM_DRAGHANDLE_ACTIVE: "draghandle-active",
  ITEM_DRAG_ACTIVE: "drag-active",

  TAB_CONTAINER: "tab-container",
  TAB_BAR: "tabbar",
  TAB_NAME: "tabs",
  TAB_COMPACT: "compact",
  TAB_SELECTOR: "detailsselector",
  
  HOVER_DROP: "drop",
  ARRANGEBAR: "arrangebar",

  BUTTON_MOVE: "move",
  BUTTON_MOVEALL: "moveall",
  BUTTON_SAVE: "save",
  BUTTON_CLOSE: "close",
  BUTTON_MERGE: "merge",
  BUTTON_DETACH: "detach",
  BUTTON_DRAGHANDLE: "draghandle",

  BUTTON_UNDO: "undo",
  BUTTON_REDO: "redo",

  DIALOG_MERGE_CONTAINER: "mergedialogcontainer",

  TEXT_BUTTON_MOVEALL: "Move Remaining",
  TEXT_BUTTON_MERGE: "Merge",
  TEXT_BUTTON_CANCEL: "Cancel",
} as const;

export type Dictionary = Record<string, any>;
export type ListItem = Dictionary;
export type List = Array<ListItem>;
export type Lists = {
  "merged": List,
  "originlists": Array<{
    "id": string,
    "name": string,
    "items": List
  }>,
  "version"?: string,
};

export let items: Lists = {
  "merged": [],
  "originlists": []
};
export let preventDetailsOpening = true;

export function setSelectors(selectors: Dictionary) {
  for (const [key, value] of Object.entries(selectors)) {
    SELECTOR[key] = value;
  }
}

export function setItems(set_items: Lists) {
  items = set_items;
}

export function setItem(id: string, item: ListItem) {
  id = id.startsWith(SELECTOR.PREFIX_MOVED) ? id.slice(SELECTOR.PREFIX_MOVED.length) : id;

  items["merged"].forEach((element: ListItem) => {
    if(element.id == id || element.id == SELECTOR.PREFIX_MOVED + id) {
      Object.assign(element, item)
    }
  });
  items["originlists"].forEach(list => {
    list["items"].forEach(element => {
      if(element.id == id) {
        Object.assign(element, item)
      }
    });
  });
}

export function setTemplates(templates: Record<string, any>) {
    ITEM_TEMPLATE = templates["item"] ? templates["item"] : "<summary>{{title}}</summary>";
    DIALOG_TEMPLATE = templates["dialog"] ? templates["dialog"] : "";
    EDIT_TEMPLATE = templates["merge"] ? templates["merge"] : "";
    DRAGHANDLE_TEMPLATE = templates["draghandle"] ? templates["draghandle"] : "";
}

export function getItem(id: string, full = false): ListItem {
  id = id.startsWith(SELECTOR.PREFIX_MOVED) ? id.slice(SELECTOR.PREFIX_MOVED.length) : id;

  let item: ListItem = {};
  items["merged"].forEach((element: ListItem) => {
    if(element.id == id) {
      item = structuredClone(element);

      if(full) {
        const merged_ids = element["mergedfrom"];
        const merged_full: Array<ListItem> = [];

        if (merged_ids) {
          merged_ids.forEach((id: string) => {
            id = id.startsWith(SELECTOR.PREFIX_MOVED) ? id.slice(SELECTOR.PREFIX_MOVED.length) : id;
            const item = getItem(id);
            item["parent_id"] = element.id;
            merged_full.push(item)
          });

          item["mergedfrom"] = merged_full;
        }
      }
    }
  });
  items["originlists"].forEach(list => {
    list["items"].forEach((element: ListItem) => {
      if(element.id == id) {
        item = structuredClone(element);
        item["parent"] = list["name"];

        if(full && element["mergedinto"] != undefined && element["mergedinto"] != "") {
          item["parent_id"] = element.id;
          item["mergedinto"] = getItem(element["mergedinto"]);
        }
      }
    });
  });

  if (item["images"] != undefined) {
    item["titleimg"] = item["images"].find((image: ListItem) => image["active"] != false);
  }

  return item;
}

export function addItemFromList(id: string, position = -1, new_id = id) {
  items["originlists"].forEach(list => {
    list["items"].forEach(element => {
      if(element.id == id) {
        let item = structuredClone(element);
        item.id = new_id;

        addMergeItem(item, position);
      }
    });
  });
}

export function removeItem(id: string) {
  items["merged"].forEach((element: ListItem) => {
    if(element.id == id) {
      const i = items["merged"].indexOf(element);
      items["merged"].splice(i, 1);
    }
  });
}

export function replaceItem(id: string, new_item: Object) {
  items["merged"].forEach((element: ListItem) => {
    if(element.id == id) {
      const i = items["merged"].indexOf(element);
      items["merged"][i] = new_item;
    }
  });
}

export function itemUpdateStatus(id: string, status: string = "") {
   items["originlists"].forEach(list => {
    list["items"].forEach(element => {
      if(element.id == id) {
        element.status = status;
      }
    });
  });
}

export function getAllItems() {
  return items;
}

export function addMergeItem(item: Object, position = -1) {
  if (position < 0) {
    position = items["merged"].length;
  }
  items["merged"].splice(position, 0, item);
}

export function updateMerged(item_id: string, mergedfrom: string[]) {
 items["merged"].forEach((element: ListItem) => {
    if(element.id == item_id) {
      element["mergedfrom"] = mergedfrom
    }
 })
}

export function updateMergedInto(item_id: string, mergedinto_id: string = item_id) {

  if(item_id == mergedinto_id) {
    mergedinto_id = "";
  }

  item_id = item_id.startsWith(SELECTOR.PREFIX_MOVED) ? item_id.slice(SELECTOR.PREFIX_MOVED.length) : item_id;
  
  items["originlists"].forEach(list => {
    list["items"].forEach(element => {
      if(element.id == item_id) {
        element["mergedinto"] = mergedinto_id;
      }
    });
  });
}

export function mergeAttach(from_id: string, to_id: string) {
  items["merged"].forEach((element: ListItem) => {
    if(element.id == to_id) {
      const tmp = element["mergedfrom"] != undefined ? element["mergedfrom"] : [from_id];
      element["mergedfrom"] = [];

      tmp.forEach((mergedfrom: string) => {
        if (mergedfrom != from_id) {
          element["mergedfrom"].push(mergedfrom);
        }
      });
    }
  });
}

export function mergeDetach(from_id: string, to_id: string) {
  from_id = from_id.startsWith(SELECTOR.PREFIX_MOVED) ? from_id.slice(SELECTOR.PREFIX_MOVED.length) : from_id;
  let previouslist: string[] = [];
  
  items["originlists"].forEach(list => {
    list["items"].forEach(element => {
      if(element.id == from_id) {
        element["mergedinto"] = "";
      }
    });
  });
  
  items["merged"].forEach(element => {
    if(element.id == to_id) {
      previouslist = element["mergedfrom"];
      element["mergedfrom"] = [];

      previouslist.forEach(mergedfrom => {
        if (mergedfrom != from_id) {
          element["mergedfrom"].push(mergedfrom);
        }
      });
    }
  });

  return previouslist;
}
